import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appCamelCaseAutoFormat]',
  standalone: true
})
export class CamelCaseAutoFormatDirective {

  constructor(private el: ElementRef) {}

  @HostListener('blur', ['$event'])
  onBlur(event: Event): void {
    const input = this.el.nativeElement as HTMLInputElement;
    const formattedValue = this.formatToCamelCase(input.value);
    
    if (input.value !== formattedValue) {
      input.value = formattedValue;
      // Trigger input event to update form control
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  /**
   * Formats a string to CamelCase (Title Case) - capitalizes first letter of each word
   * @param value - The input string to format
   * @returns Formatted string with each word capitalized
   */
  private formatToCamelCase(value: string): string {
    if (!value) {
      return value;
    }

    return value
      .split(' ')
      .map(word => {
        if (!word) {
          return word;
        }
        // Capitalize first letter and lowercase the rest
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  }
}
